import { useEffect, useRef, useState } from 'react';
import { registerServiceWorker, type ServiceWorkerHandle } from './register.ts';

/**
 * Registers the service worker once per page and reports when a new bundle is
 * waiting. Registration is skipped in development, where a cached app shell
 * would fight the dev server rather than help anyone.
 */
export function useServiceWorkerUpdate(): { updateReady: boolean; applyUpdate: () => void } {
  const [updateReady, setUpdateReady] = useState(false);
  const handle = useRef<ServiceWorkerHandle | null>(null);

  useEffect(() => {
    if (!import.meta.env.PROD) return;
    handle.current ??= registerServiceWorker(() => {
      setUpdateReady(true);
    });
  }, []);

  return {
    updateReady,
    applyUpdate: () => {
      handle.current?.applyUpdate();
    },
  };
}
